import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export default function Lightbox({ items, index, onClose, onNav }) {
  useEffect(() => {
    const h = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav(1);
      if (e.key === "ArrowLeft") onNav(-1);
    };
    document.addEventListener("keydown", h);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", h);
      document.body.style.overflow = "";
    };
  }, [onClose, onNav]);

  return (
    <AnimatePresence>
      {index != null && items[index] && (
        <motion.div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[80] flex flex-col bg-navy/95 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="flex items-center justify-between px-6 py-4 text-white">
            <span className="font-mono text-xs tracking-widest text-white/70">
              {String(index + 1).padStart(2, "0")} / {String(items.length).padStart(2, "0")}
            </span>
            <button onClick={onClose} data-testid="lightbox-close-btn" aria-label="Close lightbox" className="rounded-full p-2 transition hover:bg-white/10">
              <X size={22} />
            </button>
          </div>
          <div className="relative flex flex-1 items-center justify-center px-6 pb-4">
            <button
              onClick={() => onNav(-1)}
              aria-label="Previous image"
              className="absolute left-4 rounded-full border border-white/25 p-3 text-white transition hover:bg-white hover:text-navy"
            >
              <ChevronLeft size={20} />
            </button>
            <motion.img
              key={items[index].url}
              src={items[index].url}
              alt={items[index].title}
              initial={{ opacity: 0, scale: 0.97 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              className="max-h-[70vh] max-w-full rounded-lg object-contain shadow-2xl"
            />
            <button
              onClick={() => onNav(1)}
              aria-label="Next image"
              className="absolute right-4 rounded-full border border-white/25 p-3 text-white transition hover:bg-white hover:text-navy"
            >
              <ChevronRight size={20} />
            </button>
          </div>
          <div className="px-6 pb-6 text-center">
            <p className="text-sm font-medium text-white">{items[index].title}</p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-sky-300">{items[index].category}</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
